import { getSessionId } from './session';
import { BASE } from '../api';

const STORAGE_KEY = 'greatbreak_feed_events';
const FLUSH_INTERVAL = 5000;
const MAX_BUFFER = 50;

let eventBuffer = [];
let flushTimer = null;

function loadQueued() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

function saveQueued(events) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
  } catch {}
}

async function sendBeacon(events) {
  const url = `${BASE}/feed/events`;
  try {
    const blob = new Blob([JSON.stringify({ events })], { type: 'application/json' });
    const sent = navigator.sendBeacon(url, blob);
    if (!sent) throw new Error('sendBeacon failed');
    return true;
  } catch {
    try {
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ events }),
        credentials: 'include',
      });
      return true;
    } catch {
      return false;
    }
  }
}

async function flush() {
  const batch = eventBuffer.splice(0, MAX_BUFFER);
  if (batch.length === 0) return;

  const queued = loadQueued();
  const allEvents = [...queued, ...batch];

  const success = await sendBeacon(allEvents);
  if (success) {
    saveQueued([]);
  } else {
    saveQueued(allEvents.slice(-100));
  }
}

function scheduleFlush() {
  if (flushTimer) clearInterval(flushTimer);
  flushTimer = setInterval(flush, FLUSH_INTERVAL);
}

export function trackEvent(eventType, itemType, itemId, metadata = {}) {
  const sessionId = getSessionId();
  const event = {
    itemType,
    itemId: typeof itemId === 'string' ? parseInt(itemId) : itemId,
    eventType,
    ...(sessionId ? { sessionId } : {}),
    ...(metadata.watchMs ? { watchMs: metadata.watchMs } : {}),
  };

  eventBuffer.push(event);
  if (eventBuffer.length >= MAX_BUFFER) {
    flush();
  }
}

export function startFeedTracking() {
  scheduleFlush();

  window.addEventListener('beforeunload', flush);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
}

export function stopFeedTracking() {
  if (flushTimer) clearInterval(flushTimer);
  window.removeEventListener('beforeunload', flush);
  document.removeEventListener('visibilitychange', flush);
}
